import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ml-ui-care-plan-cell',
  templateUrl: './ui-care-plan-cell.component.html',
  styleUrls: ['./ui-care-plan-cell.component.css']
})
export class UiCarePlanCellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
